import type { PlaneSkin } from "../shared/protocol";

interface ArenaInfo { id: string; name: string; desc: string; }

const SKIN_COLORS: Record<PlaneSkin, string> = {
  0: "#ff5555",
  1: "#4ec9ff",
  2: "#f7d04c",
  3: "#6cd07a",
};

export interface HomeChoice {
  name: string;
  skin: PlaneSkin;
  arena: string;
}

export class Home {
  private el: HTMLElement;
  private nameInput: HTMLInputElement;
  private arenaSelect: HTMLSelectElement;
  private playBtn: HTMLButtonElement;
  private skinPicker: HTMLElement;
  private skin: PlaneSkin = 0;

  constructor(onPlay: (c: HomeChoice) => void) {
    this.el = document.getElementById("home")!;
    this.nameInput = document.getElementById("nameInput") as HTMLInputElement;
    this.arenaSelect = document.getElementById("arenaSelect") as HTMLSelectElement;
    this.playBtn = document.getElementById("playBtn") as HTMLButtonElement;
    this.skinPicker = document.getElementById("skinPicker")!;

    const stored = localStorage.getItem("skybreak.name") || "";
    this.nameInput.value = stored;
    const storedSkin = Number(localStorage.getItem("skybreak.skin") || "0") as PlaneSkin;
    this.skin = (storedSkin >= 0 && storedSkin <= 3 ? storedSkin : 0) as PlaneSkin;

    this.renderSkins();
    this.fetchArenas();

    this.playBtn.addEventListener("click", () => {
      const name = this.nameInput.value.trim();
      if (name.length < 2) { this.nameInput.focus(); return; }
      localStorage.setItem("skybreak.name", name);
      localStorage.setItem("skybreak.skin", String(this.skin));
      onPlay({ name, skin: this.skin, arena: this.arenaSelect.value || "skybreak" });
    });
    this.nameInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") this.playBtn.click();
    });
  }

  show() { this.el.classList.remove("hidden"); }
  hide() { this.el.classList.add("hidden"); }

  private renderSkins() {
    this.skinPicker.innerHTML = "";
    for (let i = 0 as PlaneSkin; i < 4; i = (i + 1) as PlaneSkin) {
      const tile = document.createElement("div");
      tile.className = "skin" + (i === this.skin ? " selected" : "");
      tile.innerHTML = `<div class="swatch" style="background:${SKIN_COLORS[i]}"></div>`;
      const localI = i;
      tile.addEventListener("click", () => {
        this.skin = localI;
        this.renderSkins();
      });
      this.skinPicker.appendChild(tile);
    }
  }

  private async fetchArenas() {
    let arenas: ArenaInfo[] = [];
    try {
      const r = await fetch("/api/arenas");
      arenas = await r.json();
    } catch {
      arenas = [{ id: "skybreak", name: "Skybreak", desc: "" }];
    }
    this.arenaSelect.innerHTML = "";
    for (const a of arenas) {
      const opt = document.createElement("option");
      opt.value = a.id;
      opt.textContent = `${a.name}${a.desc ? " — " + a.desc : ""}`;
      this.arenaSelect.appendChild(opt);
    }
  }
}
